import { render, staticRenderFns } from "./RequestInspectionCard.vue?vue&type=template&id=4ed4c368"
import script from "./RequestInspectionCard.vue?vue&type=script&lang=js"
export * from "./RequestInspectionCard.vue?vue&type=script&lang=js"
import style0 from "./RequestInspectionCard.vue?vue&type=style&index=0&id=4ed4c368&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports